import { useRequestProfileContext } from '../../../../RequestProfile.hooks'

import { getRemainingLabelsPayload } from './useRequestProfileWidgetLabelDelete.utils'

export function useRequestProfileWidgetLabelDelete({ labels }) {
  const { handleUpdateEntity } = useRequestProfileContext()

  async function handleDeleteLabel(labelId) {
    try {
      await handleUpdateEntity(
        getRemainingLabelsPayload({ labels, removedLabelId: labelId }),
        'Notification.CommonTitleDeletedKey'
      )
    } catch {
      // the error notification is shown by the profile's update handler
    }
  }

  return { handleDeleteLabel }
}
